/** @jsx jsx */

import { css, jsx } from '@emotion/core';

const SelectOptions = ({ children, ...props }) => {
  return (
    <div
      css={css`
        //
      `}
    >
      {children}
    </div>
  );
};

export default SelectOptions;
